module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "kp-list-item",
    attrs: {
      "ui-tree-handle": "",
      "folder-drop": "afterDrop"
    }
  }, [_c('div', {
    staticClass: "kp-folder-name kp-item-search"
  }, [_vm._v("\n    " + _vm._s(_vm.account.name) + "\n    "), (_vm.isRDDeprecated(_vm.account)) ? _c('p', {
    staticClass: "klick-deprecated-notify"
  }, [_vm._v("\n      " + _vm._s(_vm.$t('account.list.deprecated')) + "\n    ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "kp-folder-updatedate kp-item-search"
  }, [_vm._v("\n    " + _vm._s(_vm.account.type) + "\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "kp-folder-updatedate kp-item-search"
  }, [_vm._v("\n    " + _vm._s(_vm.parsedDate(_vm.account.insert_date)) + "\n  ")]), _vm._v(" "), _c('a', {
    staticClass: "modallink kp-select-open",
    on: {
      "click": function($event) {
        _vm.modalOpen('delete-account');
        _vm.setActive(_vm.account);
      }
    }
  }, [_c('i', {
    staticClass: "icon-kp-delete"
  }), _vm._v(_vm._s(_vm.$t('account.actions.delete')) + "\n  ")]), _vm._v(" "), (!_vm.isRDDeprecated(_vm.account)) ? _c('a', {
    staticClass: "modallink kp-select-open",
    on: {
      "click": function($event) {
        _vm.modalOpen('edit-account');
        _vm.setActive(_vm.account);
      }
    }
  }, [_c('i', {
    staticClass: "icon-kp-edit"
  }), _vm._v(_vm._s(_vm.$t('account.actions.edit')) + "\n  ")]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7fe43e18","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/screens/Account/components/Item.vue
// module id = 279
// module chunks = 1